import {
    ACT_CMN_TOGGLE_SIDEBAR_OFF,
    ACT_CMN_TOGGLE_SIDEBAR_ON,
} from "../constants/actions";

export const toggleSidebarOnAction = () => ({type: ACT_CMN_TOGGLE_SIDEBAR_ON});
export const toggleSidebarOffAction = () => ({type: ACT_CMN_TOGGLE_SIDEBAR_OFF});
